/**
 * Каркас страниц входа: логотип, заголовок, карточка формы.
 *
 * LoginPage и AcceptInvitePage верстали его заново — 12 общих строк
 * классов и 32 строки разметки. Закон проекта: страница собирает
 * компоненты, а не верстает их сама.
 */

import type { ReactNode } from 'react';

interface AuthLayoutProps {
  /** Подпись под названием: «Operator Console», «Приглашение» и т.п. */
  subtitle: string;
  children: ReactNode;
  /** Строка под карточкой — ссылки, подсказки */
  footer?: ReactNode;
}

export function AuthLayout({ subtitle, children, footer }: AuthLayoutProps): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-base flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8 flex flex-col items-center">
          <div className="w-12 h-12 rounded-comp bg-accent-ai/10 border border-accent-ai/20 flex items-center justify-center shadow-sm mb-4">
            <span className="text-accent-ai font-bold text-2xl">A</span>
          </div>
          <h1 className="font-heading text-3xl font-bold text-text-primary tracking-tight">
            Anima
          </h1>
          <p className="text-text-secondary mt-1 text-sm font-medium">{subtitle}</p>
        </div>

        <div className="bg-surface-elevated rounded-panel border border-border-subtle shadow-medium p-8">
          {children}
        </div>

        {footer && <div className="mt-6 text-center">{footer}</div>}
      </div>
    </div>
  );
}
